import { covid } from 'components/pages/static/content/covid'
import { MetaHead } from 'components/shared/MetaHead'
import { Box } from 'components/ui/Box'
import { Breadcrumbs } from 'components/ui/Breadcrumbs'
import { Container } from 'components/ui/Container'
import { Flex } from 'components/ui/Flex'
import { Typography } from 'components/ui/Typography'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { useTheme } from 'styled-components'

import {
  Card,
  CardBg,
  CardContentPaper,
  ContentItem,
  ContentWrapper,
  RuleBox,
  StyledListItem,
  Wrapper,
} from './styles'

export const CovidPage: FC = () => {
  const theme = useTheme()
  const { t, lang } = useTranslation('staticPages')

  const breadcrumbs = [
    {
      url: '/',
      label: t('breadcrumbs.home'),
    },
    {
      url: '/covid',
      label: t('breadcrumbs.covid'),
    },
  ]

  const covidWithTranslation = covid[lang]

  return (
    <Wrapper>
      <MetaHead page='covid' />
      <Container>
        <Box marginTop={32}>
          <Breadcrumbs links={breadcrumbs} />
        </Box>
        <Box marginTop={24}>
          <Typography as='h1' typography={theme.typography.variants.title.H1}>
            {t('covid.title')}
          </Typography>
        </Box>
        <ContentWrapper>
          <ContentItem>
            <Typography>{covidWithTranslation.description}</Typography>
            {covidWithTranslation.rules.map((rule, idx) => (
              <RuleBox key={rule} marginVertical={24}>
                <Flex container alignItems='flex-start' columnGap={16}>
                  <StyledListItem>{idx + 1}.</StyledListItem>
                  <Typography>{rule}</Typography>
                </Flex>
              </RuleBox>
            ))}
          </ContentItem>
          <ContentItem>
            <Card>
              <CardBg>
                <Image
                  src='/images/covid.png'
                  alt='COVID-19 | bile-bile.kz'
                  title='COVID-19'
                  loading='eager'
                  layout='fill'
                />
              </CardBg>
              <CardContentPaper shadow={false} radius={0}>
                <Typography typography={theme.typography.variants.title.H2}>
                  {covidWithTranslation.message}
                </Typography>
              </CardContentPaper>
            </Card>
          </ContentItem>
        </ContentWrapper>
      </Container>
    </Wrapper>
  )
}
